import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronRight } from 'lucide-react';
import './ServicesModal.css';

const ServicesModal = ({ isOpen, onClose }) => {
  const [selectedService, setSelectedService] = useState('');
  const phoneNumber = "923651512";

  const services = {
    Servicios: [
      { 
        id: 'consulta', 
        name: 'Consulta Nutricional',
        icon: '👨‍⚕️',
        description: 'Evaluación personalizada y plan nutricional adaptado a tus necesidades.' 
      },
      { 
        id: 'planes', 
        name: 'Planes Nutricionales',
        icon: '📋',
        description: 'Planes detallados para diferentes objetivos: pérdida de peso, masa muscular, salud.' 
      },
      { 
        id: 'charlas', 
        name: 'Charlas Nutricionales',
        icon: '🎯',
        description: 'Sesiones educativas para grupos sobre nutrición y vida saludable.' 
      },
      { 
        id: 'empresarial', 
        name: 'Nutrición Empresarial',
        icon: '🏢',
        description: 'Programas nutricionales para empresas y sus colaboradores.' 
      }
    ],
    Productos: [
      { 
        id: 'suplementos', 
        name: 'Suplementos',
        icon: '💊',
        description: 'Suplementos nutricionales de alta calidad para complementar tu dieta.' 
      },
      { 
        id: 'ebooks', 
        name: 'E-Books',
        icon: '📱',
        description: 'Guías digitales con recetas, consejos y planes nutricionales.' 
      }
    ]
  };

  const handleServiceClick = (serviceId) => {
    setSelectedService(serviceId);
  };

  const handleWhatsAppClick = () => {
    const selectedItem = [...services.Servicios, ...services.Productos]
      .find(item => item.id === selectedService);

    if (!selectedItem) return;

    const message = encodeURIComponent(
      `¡Hola! Me interesa información sobre: ${selectedItem.name}\n` +
      `${selectedItem.description}\n\n` +
      `¿Podrías brindarme más detalles sobre este servicio?`
    );

    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="modal-overlay"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            transition={{ duration: 0.2 }}
            className="modal-content"
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2 className="modal-title">Selecciona un Servicio o Producto</h2>
              <button className="modal-close" onClick={onClose}>
                <X size={24} />
              </button>
            </div>

            <div className="modal-body">
              {Object.entries(services).map(([category, items]) => (
                <div key={category} className="service-category">
                  <h3 className="category-title">{category}</h3>
                  <div className="service-items">
                    {items.map((item) => (
                      <motion.div
                        key={item.id}
                        className={`service-item ${selectedService === item.id ? 'selected' : ''}`}
                        onClick={() => handleServiceClick(item.id)}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <div className="service-icon">{item.icon}</div>
                        <div className="service-info">
                          <h4 className="service-name">{item.name}</h4>
                          <p className="service-description">{item.description}</p>
                        </div>
                        <ChevronRight 
                          className={`service-arrow ${selectedService === item.id ? 'visible' : ''}`}
                          size={20}
                        />
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="modal-footer">
              <button 
                className="modal-button secondary"
                onClick={onClose}
              >
                Cancelar
              </button>
              <button
                className="modal-button primary"
                onClick={handleWhatsAppClick}
                disabled={!selectedService}
              >
                Consultar por WhatsApp
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ServicesModal;